export default __webpack_public_path__ + "maps-examples-clustering-thumbnail-960-7766a0d18a17e2a0449882c67b400a1a.webp";